// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__SxUOH","menu-list":"style_menu-list__baGja","menu-empty":"style_menu-empty__Hm2X9"};